import {useState, useEffect, useRef} from 'react';

import { event_feed_list_path } from '~/routes';

export default (props, query) => {
    const page = useRef(1);
    const [data, setData] = useState([]);
    const [loadedData, setLoadedData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState(props.selectedFilters);
    const abortController = useRef(null);

    const getSearchResults = () => {
        if (loading) return;
        if (abortController.current){
            abortController.current.abort();
        }
        abortController.current = new AbortController();
        setLoading(true);
        fetch(event_feed_list_path({ search: query, event_type: selectedFilters(), page: page.current, project_id: props.projectId }))
            .then(res => res.json())
            .then(res => {
                setData(res.data);
                setLoading(false);
                setTotalCount(res.total_count);
            }, {signal: abortController.current.signal});
    }
    useEffect(() => {
        setLoading(true);
        getSearchResults();

        return (() => {
            if (abortController.current){
                abortController.current.abort();
            }
        })
    }, [filters])

    const selectedFilters = () => {
        return props.eventFeedTypes.filter((t) => (filters[t] ? t : false));
    }

    useEffect(() => {
        setFilters(props.selectedFilters);
        search();
    }, [props.selectedFilters])

    useEffect(() => {
        search();
    }, [])

    useEffect(() => {
        setLoadedData((preValue) => [...preValue, ...data]);
    }, [data])

    useEffect(() => {
        props.updateEventFeed(loadedData);
    }, [loadedData])

    function getMoreResults() {
        page.current = page.current + 1;
        getSearchResults();
    }

    function search(type = '') {
        page.current = 1;
        setLoadedData([]);
        if (type == 'all') {
            filters[type] ?
                setFilters(() => ({ all: false })) :
                setFilters(() => ({...props.eventFeedTypes.reduce((k, v) => ({ ...k, [v]: true}), {}), all: true}));
        } else {
            setFilters((prevFilters) => {
                return {...prevFilters, [type]: !prevFilters[type], all: (!prevFilters[type] && selectedFilters().length + 1 === props.eventFeedTypes.length) ? true : false }
            });
        }
    }
    return {loadedData, totalCount, loading, search, filters, getMoreResults};
}